import { render, staticRenderFns } from "./ConfirmReverseTransactionModal.vue?vue&type=template&id=72da1b5c&"
import script from "./ConfirmReverseTransactionModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmReverseTransactionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports